import { render, staticRenderFns } from "./RelatedProducts.vue?vue&type=template&id=c9e36b46"
import script from "./RelatedProducts.vue?vue&type=script&lang=js"
export * from "./RelatedProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports